<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
    <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'FEE_CHANGE.IMPORT_BTN' | translate }}
  </button>
</div>

<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
    <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'FEE_CHANGE.IMPORT_BTN' | translate }}
  </button>
</div>

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)"></app-filter>

<app-paged-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="contextMenuDefinition"
  [menuDefinition]="menuDefinition"
  [itemsSource]="itemsSource"
  [totalCount]="totalResults"
  [pageNumber]="pageNumber"
  [itemsPerPage]="pageSize"
  [preferencesKey]="preferencesKey"
  (onPageChange)="pagingChanged($event)"
  (onSortChange)="sortChanged($event)"
  (rowClick)="onRowClicked($event)"
  [isToolbarSticky]="true"
>
</app-paged-list-view>
